// LabTabs.js
import TabContext from '@mui/lab/TabContext';
import React, { useState, useMemo, useEffect } from "react";
import {
  Tabs,
  Tab,
  Box,
} from "@mui/material";
import { DataGridTable } from "./Table";
import {isTestEnv} from "../globals";

export const DataTabs = ({ data, data2, columns, TabKey, specificValue = null, checkboxSelection, handleCheckboxChange, isCheckboxVisible, handleRowClick, hideAllTab = false}) => {
  
  const [selectedTab, setSelectedTab] = useState('all');
  isTestEnv && console.log("TabKey", TabKey);  
  
  const uniqueValues = useMemo(() => {
    if (specificValue) {
      return ['all', specificValue];
    }
    const values = hideAllTab 
      ? [...new Set(data?.map(item => item[TabKey?.value]))]
      : ['all', ...new Set(data?.map(item => item[TabKey?.value]))];
    
    return values;
  }, [data, hideAllTab]);

  useEffect(() => {
    if (hideAllTab && selectedTab === 'all' && uniqueValues.length > 0 && !uniqueValues.includes('all')) {
      setSelectedTab(uniqueValues[0]);
    }
  }, [hideAllTab, uniqueValues, selectedTab]);

  isTestEnv && console.log("uniqueValues", uniqueValues);

  // Filters the data based on the selected tab.
  const filteredData = useMemo(() => {
    if (selectedTab === 'all') {
      if(data2) {
        return data2;}   
      else return data;
    }

    return data.filter(item => item[TabKey?.value] === selectedTab);
  }, [data, selectedTab]);

  isTestEnv && console.log("filteredData", filteredData);

  const handleChange = (event, newValue) => {
    setSelectedTab(newValue);
  };
  
  if (hideAllTab && uniqueValues.length === 0) {
    return (
      <Box sx={{ width: "100%" }}>
        <DataGridTable 
          columns={columns} 
          rows={data}
          checkboxSelection={checkboxSelection} 
          handleCheckboxChange={handleCheckboxChange} 
          isCheckboxVisible={isCheckboxVisible}
          handleRowClick={handleRowClick}
        />
      </Box>
    );
  }

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={selectedTab}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={selectedTab} onChange={handleChange} aria-label={`${[TabKey?.value]} tabs`}>
          {uniqueValues.map((value) => (
            <Tab 
              label={value === 'all' ? "הכל" : `${TabKey?.label} ${value}`}
              value={value} 
              key={value} 
            />
          ))}
        </Tabs>
      </Box>
      <Box sx={{ mt: 2 }}>
          <DataGridTable 
          columns={columns} 
          rows={filteredData} 
          checkboxSelection={checkboxSelection} 
          handleCheckboxChange={handleCheckboxChange} 
          isCheckboxVisible={isCheckboxVisible}
          handleRowClick = {handleRowClick}
        />
      </Box>
      </TabContext>
    </Box>
  );
};